<template>
  <v-dialog
    v-model="dialog"
    max-width="900px"
    scrollable
    @input="changeDialog($event)">
    <template v-slot:activator="{ on, attrs }">
      <div class="relative">
        <v-img
          :src="avatar"
          height="160"
          class="receipt-avatar"
          contain>
        </v-img>
        <span class="font-weight-medium">
          {{ $t('receipt.slip.size.8cm') }}
        </span>
        <div class="edit-template">
          <v-btn
            color="primary"
            rounded
            depressed
            v-bind="attrs"
            v-on="on">
            <v-icon small>
              mdi-cog
            </v-icon>
            <span> {{ $t('receipt.btn.setting') }} </span>
          </v-btn>
        </div>
      </div>
    </template>
    <card-dialog
      :title="$t('receipt.slip.cmTitle')"
      :avatar="avatar">
      <v-card
        class="app-card pt-2 pb-16 h-100 card-form-dialog"
        tile>
        <v-toolbar
          class="mb-3"
          flat
          dense>
          <v-toolbar-title class="text-subtitle-1 secondary--text font-weight-medium">
            {{ $t('receipt.editTitle') }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            small
            @click="closeDialog()">
            <v-icon small>
              mdi-close
            </v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider />
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0">
              <toggle-form
                v-model="form.invoiceShowTag"
                :text="$t('receipt.slip.field.tag.label')"
                :state="state['invoiceShowTag']"
                @input="submit('invoiceShowTag')" />
            </v-col>
            <v-col
              cols="12"
              class="pb-0">
              <toggle-form
                v-model="form.showAnnotation"
                :state="state['showAnnotation']"
                :text="$t('receipt.slip.field.note.label')"
                @input="submit('showAnnotation')" />
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </card-dialog>
  </v-dialog>
</template>

<script>
import { GET_SETTING_RECEIPT, UPDATE_SETTING } from '@/resources/graphql'
import CardDialog from '@/views/Receipt/components/CardDialog.vue'

export default {
  apollo: {
    setting: () => ({
      fetchPolicy: 'no-cache',
      query: GET_SETTING_RECEIPT,
      result ({ data: { setting } }) {
        this.form.invoiceShowTag = setting.invoiceShowTag
        this.form.showAnnotation = setting.showAnnotation
      }
    })
  },
  components: {
    CardDialog
  },
  data () {
    return {
      dialog: false,
      state: {
        invoiceShowTag: 'ready',
        showAnnotation: 'ready'
      },
      form: {
        invoiceShowTag: null,
        showAnnotation: null
      },
      invoice: {
        'false-false': `${process.env.VUE_APP_ROUTE_PREFIX}imgs/invoice/8cm/isnotTag-isnotnote.jpg`,
        'false-true': `${process.env.VUE_APP_ROUTE_PREFIX}imgs/invoice/8cm/isnotTag-isnote.jpg`,
        'true-false': `${process.env.VUE_APP_ROUTE_PREFIX}imgs/invoice/8cm/isTag-isnotnote.jpg`,
        'true-true': `${process.env.VUE_APP_ROUTE_PREFIX}imgs/invoice/8cm/isTag-isnote.jpg`
      }
    }
  },
  computed: {
    avatar () {
      const src = this.invoice[`${this.form.invoiceShowTag}-${this.form.showAnnotation}`]
      return src
    }
  },
  methods: {
    changeDialog (dialog) {
      if (dialog) { this.$apollo.queries.setting.refetch() }
    },
    closeDialog () {
      this.dialog = false
    },
    async submit (field) {
      this.state[field] = 'loading'
      const res = await this.$apollo.mutate({
        mutation: UPDATE_SETTING,
        variables: {
          input: {
            [field]: this.form[field]
          }
        }
      }).catch(() => {
        this.state[field] = 'error'
      })
      if (res) {
        const { data: { updateSetting } } = res
        if (updateSetting.errors && Object.keys(updateSetting.errors).length) {
          this.state[field] = 'error'
        } else {
          this.state[field] = 'success'
        }
      }
    }
  }
}
</script>

<style scoped>

</style>

<style>
</style>
